import React from "react";
import { VerifiedTick } from "../Icons/iconImages";
import { Button } from "../Buttons";

interface Props {
  control?: any;
  label: string;
  teamLogo: string;
  subLabel: string;
  defaultValue?: boolean;
  children?: React.ReactNode;
}

const TeamSelector: React.FC<Props> = ({ control, label, teamLogo, subLabel, defaultValue, children }) => {
  const [isDefault, setIsDefault] = React.useState<boolean>(defaultValue || false);

  const handleTeam = (type: "switchDefault" | "delete") => {
    if (type === "switchDefault") {
      setIsDefault(!isDefault);
    }
    if (type === "delete") {
      console.log("delete");
    }
  };

  return (
    <div className="flex justify-between py-4">
      <div className="flex items-center">
        {teamLogo && <span className="relative">
          <img
            className="w-10 rounded-full"
            src={teamLogo}
            alt="team-logo"
            // onError={(e: any) => {
            //   e.target.src =
            //     "https://dummyimage.com/50x50/fff/fff&text=IMG+NOT+FOUND";
            // }}
          />
          <VerifiedTick className="absolute bottom-0 right-0 w-4 h-4" />
        </span>}
        <div className="pl-2 text-sm">
          <p className="font-semibold text-[#181D27]">{label}</p>
          <p className="text-[#535862]">{subLabel}</p>
        </div>
      </div>
      {children}
      {defaultValue === undefined ? null : (
        <div className="flex items-center gap-6">
          <Button disabled={defaultValue} color="primary" onClick={() => handleTeam("switchDefault")} variant="text">
            {isDefault ? "Default" : "Set Default"}
          </Button>
          <Button danger disabled={isDefault} onClick={() => handleTeam("delete")}>Leave</Button>
        </div>
      )}
    </div>
  );
};

export default TeamSelector;
